var _a, _b;
import { IncidentImpact, IncidentIssue } from "ee-nestjs-interfaces";
/**
 * Operator-facing wording for the incident enums.
 *
 * The enum values are storage identifiers; these are what the NOC calls them.
 * Keyed by the enum rather than built from the string so that adding a value to
 * `IncidentImpact`/`IncidentIssue` is a compile error here until it is given a
 * label, instead of silently rendering as SCREAMING_SNAKE_CASE.
 */
export var IMPACT_LABELS = (_a = {},
    _a[IncidentImpact.CHARGER_OFFLINE] = "Charger(s) down",
    _a[IncidentImpact.BESS_OFFLINE] = "BESS offline",
    _a[IncidentImpact.SITE_OFFLINE] = "Site offline",
    _a);
export var ISSUE_LABELS = (_b = {},
    _b[IncidentIssue.SUSPECTED_POWER_OUTAGE] = "Suspected power outage",
    _b[IncidentIssue.CONFIRMED_POWER_OUTAGE] = "Confirmed power outage",
    _b[IncidentIssue.VANDALISM] = "Vandalism",
    _b[IncidentIssue.PREVENTATIVE_MAINTENANCE] = "Preventative maintenance",
    _b[IncidentIssue.FORCE_MAJEURE] = "Force majeure",
    _b[IncidentIssue.TELECOMMUNICATIONS_FAILURE] = "Telecommunications failure",
    _b[IncidentIssue.HARDWARE_FAILURE] = "Hardware failure",
    _b[IncidentIssue.COMMISSIONING] = "Commissioning",
    _b[IncidentIssue.THIRD_PARTY_DAMAGE] = "Third Party Damage",
    _b);
export var impactLabel = function (impact) { var _a; return (_a = IMPACT_LABELS[impact]) !== null && _a !== void 0 ? _a : impact; };
export var issueLabel = function (issue) { var _a; return (_a = ISSUE_LABELS[issue]) !== null && _a !== void 0 ? _a : issue; };
